import type { User } from "@/features/users/schemas/user";

/**
 * Obtiene el nombre completo del usuario según su tipo.
 * @param user - El usuario
 * @returns El nombre formateado
 */
export const getUserFullName = (user: User): string => {
  if (user.type === "institution") {
    return user.name || "Sin nombre";
  }

  if (user.forename || user.surname) {
    return [user.forename, user.surname].filter(Boolean).join(" ");
  }

  return user.name || "Sin nombre";
};

/**
 * Obtiene las iniciales del usuario basándose en su nombre completo.
 * @param user - El usuario
 * @returns Las iniciales (máximo 2 caracteres)
 */
export const getUserInitials = (user: User): string => {
  const fullName = getUserFullName(user);
  return fullName
    .split(" ")
    .map((n) => n[0])
    .filter(Boolean)
    .join("")
    .toUpperCase()
    .slice(0, 2);
};
